import api from '../axiosInstance';
import { ADMIN_ENDPOINTS } from '../constants';
import { encodeBase64 } from '../../utils/base64Util';
export const listAdmins = () => {
  return api.get(ADMIN_ENDPOINTS.LIST);
}

export const getAdminDetails = async (adminId) => {
  return api.get(ADMIN_ENDPOINTS.GET_By_ID(adminId));
}

export const createAdmin = async (adminDetails) => {
  const data = {
    f_name : adminDetails.first_name,
    l_name : adminDetails.last_name,
    email : adminDetails.email_id,
    mobile : adminDetails.mobile,
    cred : encodeBase64(adminDetails.password),
    status : adminDetails.admin_status === 'Active' ? "true" : "false",
  }
  return api.post(ADMIN_ENDPOINTS.CREATE, data)
}

export const editAdmin = async (adminDetails) => {
  const data = {
    f_name : adminDetails.first_name,
    l_name : adminDetails.last_name,
    mobile : adminDetails.mobile,
    status : adminDetails.admin_status === 'Active' ? "true" : "false",
  }
  return api.put(ADMIN_ENDPOINTS.UPDATE(adminDetails.admin_id), data)
}

export const deleteAdmin = async (adminId) => {
  return api.delete(ADMIN_ENDPOINTS.DELETE(adminId))
} 

export const showPassCode = async (adminId) => {
  return api.get(ADMIN_ENDPOINTS.PASSCODE(adminId))
}